import axios from 'axios';
import React, {useEffect, useMemo, useState} from 'react';
import Confetti from 'react-dom-confetti';
import {toast} from 'react-toastify';
import {Button, Col, Modal, ModalBody, Row} from 'reactstrap';
import {SERVER_API_URL, CLIENT_ID_FRIST, CLIENT_ID_SECOND} from './constants';
import './home.scss';
import {RowItemGame} from './row-item';
import machine from './images/slot-machine.png';
import banner from './images/Artboard_55.png';


export type SpinHistories = {
    id?: number;
    cif?: string | null;
    sprinDate?: string | null;
    amount?: number | null;
    status?: string | null;
    sendDate?: string | null;
    sendBy?: string | null;
    gift?: {
        id?: number;
        giftName?: string | null;
        value?: number | null;
        price?: number | null;
        description?: string | null;
        gift_description?: string | null;
        amount?: number | null;
        amountUsed?: number | null;
        avaiable?: number | null;
        sprinRates?: Object | null;
        config?: Object | null;
        luckyDraw?: Object | null;
    } | null;
    customerSprin?: Object | null;
    customerCode?: string | null;
    customer?: Object | null;
    luckyDraw?: { giftTypeAlias: string | null };
}

export type gift = {
    prize?: number;
    giftName?: string | null;
    giftValue?: number | null;
    giftType?: string | null;
    giftDescription?: string | null;
}

export const Home = (props: any) => {
    const widthScreen = window.screen.width;
    const hightScreen = window.screen.height;
    /* eslint-disable */
    const params = window.location.search;
    const paramId = params?.replace('?token=', '');
    /* eslint-disable */
    // console.log('>>>>>>>>>>>>>', widthScreen, hightScreen, paramId);
    // const { account } = props;
    const [spin, setSpin] = useState(false);
    const [spinCombo, setspinCombo] = useState(false);
    const [listGift, setlistGift] = useState(false);
    const [ring1, setRing1] = useState(0);
    const [ring2, setRing2] = useState(0);
    const [ring3, setRing3] = useState(0);
    const [price, setPrice] = useState(0 || undefined);
    const [inputValue, setInputValue] = useState(100);
    const [avaiableSpin, setAvaiableSpin] = useState('0');
    const [gift, setGift] = useState({giftName: '', giftValue: '', giftType: ''});
    const [listgift, setListgift] = useState([]);
    const [reload, setReload] = useState(true);
    const [typeModal, setTypeModal] = useState('');
    const [open, setOpen] = useState(false);
    const [disableOclick, setDisableOclick] = useState(false);
    const [focusAfterClose, setFocusAfterClose] = useState(true);
    const [prize, setPrize] = useState(0);
    const [openFireWork, setOpenFireWork] = useState(false);
    const [openDraw, setOpenDraw] = useState(false);
    const [history, setHistory] = useState([]);

    const [page, setPage] = useState({page:0,size:20});
    const [combonum, setcombonum] = useState(10);
    const [mess, setMess] = useState('');

    const comborequest = {jwtToken:paramId ,numcombo:combonum}

    axios.defaults.baseURL = SERVER_API_URL;
    axios.defaults.headers.common['' + CLIENT_ID_FRIST] = CLIENT_ID_FRIST
    axios.defaults.headers.common['' + CLIENT_ID_SECOND] = CLIENT_ID_SECOND
    const initData = async () => {
        if (reload) {
            const resppose = await axios.get('api/luckydraw/init?token=' + paramId).then(
                function (response) {
                    setAvaiableSpin(response.data?.avaiableSpin);
                    setReload(false);
                },
                function (error) {
                    if ('' + error.response?.status === '428') {
                        toast.info('Chương trình hiện tại đang trong quá trình bảo trì trong ít phút');
                    }
                    setReload(false);
                }
            );
        }
    };

    const spinHistory = async () => {
        setDisableOclick(true);
        const resppose = await axios.get('api/luckydraw/history?token=' + paramId +"&page="+page.page+"&size="+page.size+"&sort=id,desc&cacheBuster").then(
            function (response) {
                if (Array.isArray(response.data)) {
                    var newdata = response.data as [];
                    setHistory(newdata);
                }
            },
            function (error) {
                setReload(false);
            }
        );
        setDisableOclick(false);
        setTypeModal('history');
        setOpen(true);
        setReload(false);
    };

    useEffect(() => {
        if(history.length > 0){
            spinHistory();
        }
    }, [page]);

    useEffect(() => {
        initData();
    }, [reload]);
    const rand = async (audio: HTMLAudioElement) => {
        console.log(paramId);
        const resppose = await axios.post('api/luckydraw/spin', paramId).then(
            function (response) {
                // const audio = document.getElementById("audio") as HTMLAudioElement;
                setTimeout(function () {
                    audio.pause();
                    if ('' + response.data?.giftValue === '0') {
                        setTypeModal('lost');

                        setTimeout(function () {
                            audio.volume = audio.volume / 2;
                            setRing1(0);
                        }, 500);
                        setTimeout(function () {
                            setRing2(0);
                        }, 1000);
                        setTimeout(function () {
                            setRing3(0);
                            setSpin(false);
                        }, 1000);
                        setTimeout(function () {
                            setPrize(0);
                            setReload(true);
                            setOpen(true);
                            setOpenFireWork(false);
                        }, 500);
                    } else {
                        const giftTmp = {
                            giftName: response.data?.giftName,
                            giftValue: response.data?.giftValue,
                            giftType: response.data?.giftType
                        };
                        setGift(giftTmp);
                        setTypeModal('win');
                        switch (response.data.prize) {
                            case 1:
                                setTypeModal('win');
                                setPrize(1);
                                setRing1(1);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(1);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(1);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);

                                }, 1500);
                                break;
                            case 2:
                                setTypeModal('win');
                                setPrize(2);
                                setRing1(2);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(2);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(2);
                                    setSpin(false);
                                }, 1000);

                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 3100);
                                break;
                            case 3:
                                setTypeModal('win');
                                setPrize(3);
                                setRing1(3);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(3);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(3);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 3000);
                                break;

                            case 4:
                                setTypeModal('win');
                                setPrize(4);
                                setRing1(4);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(4);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(4);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 3000);
                                break;

                            case 5:
                                setTypeModal('win');
                                setPrize(5);
                                setRing1(5);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(5);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(5);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 3100);
                                break;

                            case 6:
                                setTypeModal('win');
                                setPrize(6);
                                setRing1(6);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(6);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(6);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 3100);
                                break;

                            case 7:
                                setTypeModal('win');
                                setPrize(7);
                                setRing1(7);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(7);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(7);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 3100);
                                break;

                            case 8:
                                setTypeModal('win');
                                setPrize(8);
                                setRing1(8);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(8);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(8);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 2200);
                                break;

                            case 9:
                                setTypeModal('win');
                                setPrize(9);
                                setRing1(9);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(9);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(9);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                setInterval(() =>
                                {
                                    setOpenFireWork(true);
                                }, 2200);
                                break;


                            case 10:
                                setTypeModal('lost');
                                setPrize(0);
                                setRing1(0);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 2;
                                    setRing2(0);
                                }, 500);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 4;
                                    setRing3(0);
                                    setSpin(false);
                                }, 1000);
                                setTimeout(function () {
                                    audio.volume = audio.volume / 10;
                                    setReload(true);
                                    setOpen(true);
                                }, 1500);
                                break;
                        }
                    }

                }, 1000);

            },
            function (error) {
                setRing1(Math.floor(Math.random() * (100 - 1) + 1));
                setTimeout(function () {
                    setRing2(Math.floor(Math.random() * 25 + 50));
                }, 500);
                setTimeout(function () {
                    setRing3(Math.floor(Math.random() * (100 - 35) + 10));

                }, 500);
                setTimeout(function () {
                    // audio.pause();
                    toast.info('Hệ thống đang bảo trì, vui lòng quay lại sau.');
                    setReload(true);
                }, 100);

            }
        );
    };

    const randcombo = async (audio: HTMLAudioElement) => {
        const resppose = await axios.post('api/luckydraw/spincombo',comborequest).then(
            function (response) {

                setTimeout(function () {
                    setListgift(response.data);
                    setTypeModal('combo');
                    setReload(true);
                    setOpen(true);
                }, 2000);

                setTimeout(function () {
                    audio.volume = audio.volume / 4;
                    setRing3(90);
                    setSpin(false);
                }, 1000);

                setInterval(() =>
                {
                    setOpenFireWork(true);
                }, 2200);

            });
    };

    const playcombo = () => {
        if (spin) {
            return;
        }
        if (Number(avaiableSpin) < combonum) {
            setTypeModal('noround');
            setOpen(true);
            setMess('bạn hiện tại không đủ 10 lượt quay')
            return;
        }
        const audio = new Audio("./music/tiktok.mp3");
        audio.setAttribute("preload", "auto");
        audio.setAttribute("controls", "none");
        audio.setAttribute("id", "audio");
        audio.style.display = "none";
        audio.onreset;
        audio.currentTime = 0;
        audio.load();
        audio.play();
        setRing1(0);
        setRing2(0);
        setRing3(0);
        setSpin(true);
        setOpenFireWork(false);
        randcombo(audio);
    };

    const play = () => {
        if (spin) {
            return;
        }
        if (Number(avaiableSpin) < 1) {
            setTypeModal('noround');
            setOpen(true);
            setMess('bạn hiện tại đã hết lượt quay')
            return;

        }
        const audio = new Audio("./music/tiktok.mp3");
        audio.setAttribute("preload", "auto");
        audio.setAttribute("controls", "none");
        audio.setAttribute("id", "audio");
        audio.style.display = "none";
        audio.onreset;
        audio.currentTime = 0;
        audio.load();
        audio.play();
        setRing1(0);
        setRing2(0);
        setRing3(0);
        setSpin(true);
        rand(audio);
    };
    const toggle = () => {
        setSpin(false);
        setOpenFireWork(false);
        setOpen(!open);
    };
    const getTop = () => {
        if (widthScreen >= 720) {
            return '34%';
        }
        if (hightScreen / widthScreen < 1.5) {
            return '23%';
        }
        if (widthScreen >= 400 && hightScreen < 650) {
            return '27%';
        }
        if (widthScreen >= 400 && hightScreen < 700) {
            return '29%';
        }
        if (widthScreen >= 400 && hightScreen < 800) {
            return '32%';
        }
        if (widthScreen >= 400 && hightScreen > 800) {
            return 30.5 + hightScreen / widthScreen + '%';
        }
        if (hightScreen / widthScreen >= 2 && widthScreen < 375) {
            return '32%';
        }

        if (hightScreen / widthScreen >= 2) {
            return '34%';
        }
        if (widthScreen * 1.5 < hightScreen && hightScreen < widthScreen * 1.7) {
            return '28%';
        }
        return hightScreen > 1.7 * widthScreen && widthScreen > 375 ? '33%' : '29.8%';
    };

    const getHeight = () => {
        if (widthScreen >= 720) {
            return '26.5%';
        }
        if (widthScreen >= 720 && hightScreen < 1100) {
            return '24%';
        }
        if (hightScreen / widthScreen < 1.5) {
            return '36%';
        }
        if (widthScreen >= 400 && hightScreen < 650) {
            return '30.5%';
        }
        if (widthScreen >= 400 && hightScreen < 700) {
            return '29%';
        }
        if (widthScreen >= 400 && hightScreen < 800) {
            return '26.5%';
        }
        if (widthScreen >= 400 && hightScreen > 800) {
            return 22.5 + hightScreen / widthScreen + '%';
        }
        if (hightScreen / widthScreen >= 2) {
            return '23%';
        }
        return '26.5%';
    };


    const RingItemGame1 = useMemo(() => {
        if (typeModal === 'win') {
            switch (prize) {
                case 0:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 1:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 2:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 3:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 4:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 5:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 6:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                case 7:
                    return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen}
                                        hightScreen={hightScreen} prize={prize}/>;
                default:
                    break;
            }
        }
        setOpenFireWork(false);
        return <RowItemGame ring1={ring1} spin={spin} type={'ring1'} widthScreen={widthScreen} hightScreen={hightScreen}
                            prize={prize}/>;
    }, [spin === true]);
    const RingItemGame2 = useMemo(() => {
        if (typeModal === 'win') {
            setTimeout(function () {
                switch (prize) {
                    case 0:
                        return <RowItemGame ring2={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 1:
                        return <RowItemGame ring2={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 2:
                        return <RowItemGame ring2={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 3:
                        return <RowItemGame ring2={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 4:
                        return <RowItemGame ring1={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 5:
                        return <RowItemGame ring1={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 6:
                        return <RowItemGame ring1={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 7:
                        return <RowItemGame ring1={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    default:
                        break;
                }
            }, 500);
        }
        setOpenFireWork(false);
        return <RowItemGame ring2={ring2} spin={spin} type={'ring2'} widthScreen={widthScreen} hightScreen={hightScreen}
                            prize={prize}/>;
    }, [spin === true]);
    const RingItemGame3 = useMemo(() => {
        if (typeModal === 'win') {
            setTimeout(function () {
                switch (prize) {
                    case 0:
                        return <RowItemGame ring3={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 1:
                        return <RowItemGame ring3={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 2:
                        return <RowItemGame ring3={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 3:
                        return <RowItemGame ring3={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 4:
                        return <RowItemGame ring1={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;

                    case 5:
                        return <RowItemGame ring1={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 6:
                        return <RowItemGame ring1={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    case 7:
                        return <RowItemGame ring1={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen}
                                            hightScreen={hightScreen} prize={prize}/>;
                    default:
                        break;
                }
            }, 1000);
        }
        setOpenFireWork(false);
        return <RowItemGame ring3={ring3} spin={spin} type={'ring3'} widthScreen={widthScreen} hightScreen={hightScreen}
                            prize={prize}/>;
    }, [spin === true]);
    const config = {
        angle: 90,
        spread: 360,
        startVelocity: 60,
        elementCount: 300,
        dragFriction: 0.25,
        duration: 4700,
        stagger: 3,
        width: '10px',
        height: '10px',
        perspective: '1000px',
        colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
    };
    const formatMoney = (amountData: string, decimalCount = 2, thousands = ".") => {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = "";

            const i = parseInt(Math.abs(Number(amountData) || 0).toFixed(decimalCount), 0).toString();
            const j = (i.length > 3) ? i.length % 3 : 0;
            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);

        } catch (e) {
            return '' + amountData
        }
    };
    

    return (
        <div className='container'>
            <Row>
            <div
                className="fullSlot"
                style={{height:hightScreen - 50}}
            >
                <div className='col-sm-12'>
                    <div>
                        <img src={banner} style={{
                    maxWidth: '23rem',
                    maxHeight: '15rem'
                }} />
                    </div>
                    <div className='total-number'
                    >
                        <span className="total-sprin-style">{avaiableSpin ? avaiableSpin : 0}</span>
                        <span className="total-sprin-text-style">
                            lượt quay
                        </span>
                    </div>
                </div>
                    <div className='machine'>
                        <div className='col-sm-12'>
                    <img src={machine} className="image"/>
                    <div className="slot number">
                        <div
                            className="row-item-left"
                            style={{
                                width: '4rem'
                            }}
                        >
                            {RingItemGame1}
                        </div>
                        <div
                            className="row-item"
                            style={{
                                width: '4rem'
                            }}
                        >
                            {RingItemGame2}
                        </div>
                        <div
                            className="row-item-right"
                            style={{
                                width: '4rem'
                            }}
                        >
                            {RingItemGame3}
                        </div>
                    </div>
                    
                    </div>
                </div>
                <div className='bottom'>
                <div className="button-group">
                    <img
                            src="./images/Artboard84.png"
                            className="giftButton"
                            style={{margin:4}}
                            onClick={() => {
                                play();
                            }}
                        />
                        <img
                            src="images/Artboard85.png"
                            className="giftButton"
                            style={{margin:4}}
                            onClick={() => {
                                playcombo();
                            }}
                        />
                </div>
                <div className="button-group mt-1">
                        <img
                            src="images/button-gift.png"
                            alt="Quà tặng của tôi"
                            title="Quà tặng của tôi"
                            className=" git-icon"
                            onClick={() => {
                                if (spin || disableOclick) {
                                    return;
                                }
                                spinHistory();
                            }}
                        />
                        <img
                            src="images/button-rule.png"
                            alt="Thể lệ chương trình"
                            title="Thể lệ chương trình"
                            className=" git-icon"
                            onClick={() => {
                                if (spin) {
                                    return;
                                }
                                setTypeModal('rules');
                                setOpen(true);
                            }}
                        />
                </div>
                </div>
            </div>
            <Modal
                returnFocusAfterClose={focusAfterClose}
                isOpen={open}
                className="modal-style"
            >
                {/* <ModalHeader toggle={toggle} charCode="X"></ModalHeader> */}
                <div style={{zIndex: '9999'}} onClick={() => toggle()}>
                    <img src="images/button-X.png" alt="Quà tặng của tôi" className="btn-close-modal year"/>
                </div>
                <span className="tittle-modal">
                    {typeModal === 'win' || typeModal === 'lost' ? (
                        <img src="images/luck_header.png"  alt="Thể lệ" className="img-header-style"/>
                    ) : typeModal === 'rules' ? (
                        <img src="images/rule_header.png" alt="Thể lệ" className="img-header-style"/>
                    ) : typeModal === 'combo' ? (
                         <img src="images/gift_header.png" alt="Thể lệ" className="img-header-style"/>
                    ) : (
                        <img src="images/gift_header.png"   alt="Lịch sử quay thưởng" className="img-header-style"/>
                    )}
                </span>
                <ModalBody >
                    {open ? <Confetti active={openFireWork} config={config}/> : null}
                    {typeModal === 'win' ? (
                        <div style={{display: 'block', textAlign: 'center'}}>
                            <img
                                src="images/gift-box-detail.png"
                                alt="Quà tặng của tôi"
                                className="box-img-style"
                                onClick={() => toggle()}
                            />
                        </div>
                    ) : typeModal === 'lost' ? (
                        <div style={{display: 'block', textAlign: 'center'}}>
                            <img src="images/icon.png" alt="Quà tặng của tôi" className="box-img-style"
                                 onClick={() => toggle()}/>
                        </div>
                    ) : typeModal === 'noround' ? (
                        <div style={{display: 'block', textAlign: 'center'}}>
                            <img src="images/icon-2.png" alt="Quà tặng của tôi" className="box-img-style"
                                 onClick={() => toggle()}/>
                        </div>
                    ) : typeModal === 'rules' ? (
                        <div style={{display: 'block', textAlign: 'left', overflowY:"scroll",height:getHeight()}}>
                            <div>
                                <span style={{fontWeight: 'bold', color: '#2d80bf'}}>Thể lệ chương trình:</span>
                            </div>
                            <div>
                                <span>Thực hiện mở gói tài khoản thanh toán, thực hiện giao dịch qua PV Mobile Banking để nhận lượt quay và có cơ hội trúng các giải thưởng</span>
                            </div>
                            <div>
                                <span style={{fontWeight: 'bold', color: '#2d80bf'}}>Cơ cấu giải thưởng:</span>
                            </div>
                            <div>
                                <table className="table" style={{fontSize: 11}} >
                                    <thead>
                                    <tr>
                                        <th scope="col">Loại giải</th>
                                        <th scope="col">Hiển thị</th>
                                        <th scope="col">giải thưởng (VNĐ)</th>
                                    </tr>
                                    </thead>
                                    <tbody style={{fontWeight: 'bold'}}>
                                    <tr>
                                        <td>Giải Đặc biệt</td>
                                        <td>999</td>
                                        <td>5,000,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Kim Cương</td>
                                        <td>888</td>
                                        <td>1,000,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải vàng</td>
                                        <td>666</td>
                                        <td>500,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Bạc</td>
                                        <td>333</td>
                                        <td>100,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Đồng</td>
                                        <td>222</td>
                                        <td>50,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Nhất</td>
                                        <td>111</td>
                                        <td>10,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Nhì</td>
                                        <td>444</td>
                                        <td>5,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Ba</td>
                                        <td>555</td>
                                        <td>2,000</td>
                                    </tr>

                                    <tr>
                                        <td>Giải Khuyến khích</td>
                                        <td>777</td>
                                        <td>1,000</td>
                                    </tr>

                                    </tbody>
                                </table>


                            </div>
                            <div>
                                <p><span style={{fontWeight: 'bold', color: '#2d80bf'}}>Thời gian: </span>
                                    Từ 0h00p ngày 28 tháng 09 năm 2022 đến 23h59 ngày 27 tháng 10 năm 2022. </p>
                            </div>
                        </div>
                    ) : typeModal === 'history' && history && history.length > 0 ? (
                        <div style={{overflow: 'scroll', height: hightScreen/3 * 2 , minHeight:'200px', minWidth: '280px',marginTop:4}}>
                            {history.map((v: SpinHistories, i) => {
                                return '' + v.gift?.value !== '0' ? (
                                    <Row style={{
                                        display: 'inline-flex',
                                        marginBottom: '5px',
                                        borderBottom: '0.1px solid #000',
                                        width: '100%'
                                    }} key={i}>
                                        <Col className="gif-box-history col-sm-3" key={i}>
                                            <img
                                                src="images/gift-box.png"
                                                alt="Quà tặng của tôi"
                                                className="giftButton btn-modal-tyle img-box-his"
                                            />
                                        </Col>
                                        <Col style={{width: '100%',fontSize:14}} >
                                            <div>Ngày quay: {v.sprinDate?.substring(0, 10)}</div>
                                            <div className="row">
                                                <span style={{fontWeight:"bold"}}> {v.gift?.gift_description} {formatMoney('' + v.gift?.value)} {v.luckyDraw?.giftTypeAlias}</span>
                                            </div>
                                        </Col>

                                    </Row>
                                ) : null;
                            })}
                            {/*<p style={{textAlign:"center", fontWeight:"bold", cursor:"pointer", color:"blue"}}*/}
                            {/*onClick={()=> setPage({page:page.page+1,size:2000}) }*/}
                            {/*>Xem thêm</p>*/}
                        </div>


                    ) : typeModal == 'combo' && listgift && listgift.length > 0 ? (
                        <div style={{overflow: 'scroll', maxHeight: getHeight(), minWidth: '280px', marginTop: '4px'}}>
                            <p style={{textAlign:"center",fontWeight:"bold"}}>GIẢI THƯỞNG TRONG 10 LƯỢT QUAY</p>
                            {listgift.map((v: gift, i) => {
                                return (

                                        <Row style={{
                                            display: 'inline-flex',
                                            marginBottom: '5px',
                                            borderBottom: '0.1px solid #000',
                                            width: '100%',
                                        }} key={i}>
                                            <Col className="col-sm-12" style={{margin: 4}} key={i}>
                                                    Lượt {i+1}: {v.prize!=10 ? <label style={{fontWeight:"bold"}}>{formatMoney('' + v.giftValue)} VND </label> : ''} ({v.giftDescription})
                                            </Col>
                                        </Row>

                                );
                            })}
                        </div>

                    ) : (
                        <Row className="gift-name-style" style={{marginTop: '25px'}}>
                            <span style={{alignContent: 'center', marginRight: 15, fontSize: '20px'}}>Vui lòng quay thưởng để có quà.</span>
                        </Row>
                    )}
                    {typeModal === 'win' ? (
                        <div className="gift-name-style" style={{fontSize: gift.giftValue === '0' ? 20 : 25}}>

                        </div>
                    ) : typeModal === 'lost' ? (
                        <div className="gift-name-style" style={{marginTop: 15}}>Chúc bạn may mắn lần sau</div>
                    ) : typeModal === 'noround' ? (
                        <div className="gift-name-style">{mess}</div>
                    ) : null}
                    {typeModal === 'win' && '' + gift.giftValue !== '0' ? (
                        <div style={{justifyContent: 'center', textAlign: 'center'}}>
                            Giải thưởng: <span style={{
                            fontWeight: 'bold',
                            color: '#2d80bf',
                            fontSize: 20
                        }}>{formatMoney('' + gift.giftValue)} </span>

                            {gift.giftType.toLowerCase().includes('điểm') ?
                                <div style={{marginTop: 5}}>Điểm <img src="../images/pvone.png" alt="" style={{
                                    width: '25%',
                                    height: '25%',
                                    paddingBottom: 5
                                }}/></div>
                                : gift.giftType}

                        </div>
                    ) : null}
                    {typeModal === 'win' || typeModal === 'lost' || typeModal === 'noround' || typeModal === 'combo' ? (
                        <Row style={{marginTop: '15px'}}>
                            <Col className="mb-1">
                                    {typeModal === 'win' || typeModal === 'lost' ? (
                                        <img
                                            src="images/button-respin.png"
                                            alt="Chơi tiếp"
                                            className="giftButton"
                                            onClick={() => {
                                                setSpin(false);
                                                setOpen(false);
                                                play();
                                            }}
                                        />

                                    ) : typeModal === 'combo' ?
                                        (
                                            <img
                                                src="images/button-respin-10.png"
                                                alt="Chơi tiếp"
                                                className="giftButton next10"
                                                onClick={() => {
                                                    setSpin(false);
                                                    setOpen(false);
                                                    playcombo();
                                                }}
                                            />
                                        )
                                        :(
                                        null
                                    )}
                            </Col>

                            <Col className="mb-1">
                                    {typeModal === 'win' || typeModal === 'lost' ? (
                                        <img
                                            src="images/button-respin-10.png"
                                            alt="Chơi tiếp x10"
                                            className="giftButton"
                                            onClick={() => {
                                                setSpin(false);
                                                setOpen(false);
                                                playcombo();
                                            }}
                                        />

                                    ) : typeModal == 'noround' ? (
                                            null
                                    ) :
                                        null
                                    }
                            </Col>

                        </Row>
                    ) : null}
                </ModalBody>
            </Modal>
            <audio id="audio" src="./music/tiktok.mp3" style={{display: 'none'}}></audio>
            </Row>
            </div>
    );
};

export default Home;
